import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Countries, RedirectService } from '../../../services/redirect.service';
import { Langs } from '../../../services/translation.service';

@Component({
  selector: 'nr-select-language-dialog',
  templateUrl: './select-language-dialog.component.html',
  styleUrls: ['./select-language-dialog.component.scss'],
})
export class SelectLanguageDialogComponent  {
  public language = '';

  constructor(
    public dialogRef: MatDialogRef<SelectLanguageDialogComponent>,
    public redirectService: RedirectService,
  ) {}

  public onContinueClick() {
    switch (this.language) {
      case `${Langs.Russian}_${Countries.Russia}`: {
        this.redirectService.goToYandex();
        break;
      }
      default: {
        this.redirectService.goToNaver(this.language);
        break;
      }
    }
  }

  public onSelectLanguage(language: string) {
    this.language = language;
  }
}
